import React, {useEffect, useRef,useState} from 'react';

import {ArrowDownward as ArrowDownIcon, ArrowUpward as ArrowUpIcon, Settings as SettingsIcon} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Box,
    IconButton,
    Stack,
    Typography} from '@mui/material';
import {useMediaQuery, useTheme} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import {homeLineup} from 'assets/lineups';
import {hasTeamPlayersOnCanvas} from 'canvas/Drawer/player-utils';
import {useCanvasStore} from 'canvas/zustand';
import {useTranslation} from 'hooks';
import {colors} from 'layout/components/toolbar/components/ColorTool';
import {TeamLineup} from 'module/client/team';
import {Edit} from 'module/client/team';
import {TeamSelector} from 'module/client/team/index';
import {useApiQuery} from 'module/client/team/member/useMemberApi';
import {useDrawTeamLineup} from 'module/client/team/useLineup';
import {useApiRead} from 'module/client/team/useTeamApi';
import {useApiQuery as useClientApiQuery} from 'module/client/useClientApi';
import {useSettingsStore} from 'module/settings/zustand';
import {useSheet,useSheetUpdate} from 'module/sheet/useSheet';
import {useLayoutStore, usePrefsStore} from 'store';

import {Player} from './Player';
const styles = {
    drawerInvisible: {
        opacity: 0,
        transition: 'opacity 0.3s ease-in-out',
    },
    accordion: theme => ({
        width: '100%',
        background: theme.palette.grey.darker,
        borderRadius: '8px !important',
        marginBottom: '8px',
        position: 'relative',
        zIndex: 1,
        flexShrink: 0,
    }),
    accordionLast: {
        marginBottom: 0,
    },
    accordionActive: theme => ({
        background: theme.palette.lineup.buttonBgSelected,
    }),
    accordionSummary: {
        padding: '0 16px',
        '& .MuiAccordionSummary-expandIconWrapper': {
            color: '#fff',
            '&.Mui-expanded': {
                color: '#fff',
            }
        }
    },
    accordionDetails: theme => ({
        padding: 0,
        background: theme.palette.lineup.accordionDetailsBg,
        borderTop: `1px solid ${theme.palette.lineup.accordionDetailsBorder}`,
        justifyContent: 'flex-start',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    }),
    accordionTitle: theme => ({
        textAlign: 'center',
        width: '100%',
        fontSize: '14px',
        color: theme.palette.lineup.textPrimary,
    }),
    accordionTitleActive: theme => ({
        color: theme.palette.green.lineup,
    }),
    teamTitle: theme => ({
        textAlign: 'center',
        width: '100%',
        fontSize: '14px',
        color: theme.palette.lineup.textPrimary,
        marginBottom: '8px',
        fontWeight: 'bold',
    }),
    iconBoxGroup: theme => ({
        padding: '12px',
        width: '90px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        //borderRadius: '10px',
        //background: theme.palette.lineup.iconBoxBg,
        //border: `2px solid ${theme.palette.lineup.iconBoxBorder}`,
        cursor: 'pointer',
        position: 'relative',
        background: theme.palette.grey.darker,
        marginBottom: '12px',

        '&:hover': {

            background: theme.palette.grey.darker,

            '& .MuiBox-root': {

                color: theme.palette.green.lineup,

                '& > svg': {
                    color: theme.palette.green.lineup,
                }
            },

            '& .MuiTypography-root': {

                color: theme.palette.green.lineup,
            }
        }
    }),
    iconBoxGroupSelected: theme => ({
        background: theme.palette.grey.darker,
        width: '120px',
        '& .MuiBox-root': {

            color: theme.palette.green.lineup,

            '& > svg': {
                color: theme.palette.green.lineup,
            }
        },

        '& .MuiTypography-root': {

            color: theme.palette.green.lineup,
        }
    }),
    iconBox: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    iconBoxText: theme => ({
        fontSize: '13px',
        fontWeight: '400',
        color: theme.palette.lineup.textPrimary,
        textTransform: 'uppercase',
        marginTop: '12px',
    }),
    icon: {
        width: '100px',
        overflow: 'visible',
    },
    toggleButtonGroup: {
        padding: '10px',
        justifyContent: 'center',
    },
    buttonInvisible: {
        opacity: 0.6,
    },
    directionButton: theme => ({
        padding: 0,
        width: '46px',
        height: '46px',
        margin: '4px',
        color: theme.palette.lineup.textPrimary,
        background: theme.palette.grey.darker,
        borderRadius: '23px',
        overflow: 'hidden',
        fontSize: '14px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        '&:hover': {
            color: theme.palette.green.lineup,
            background: theme.palette.grey.darker,
        },
        '&.Mui-disabled': {
            background: theme.palette.grey.darker,
            color: theme.palette.green.lineup,
        }
    }),
    directionButtonActive: theme => ({
        width: '60px',
        height: '60px',
        color: theme.palette.green.lineup,
        borderRadius: '30px',
        '& svg': {
            fontSize: '30px',
        },
    }),
    settingsButton: theme => ({
        padding: '10px',
        color: theme.palette.lineup.textPrimary,
        background: theme.palette.lineup.playerBg,
        border: `1px solid ${theme.palette.lineup.playerBorder}`,
        borderRadius: '10px',
    }),
    playerShirt: {
        overflow: 'hidden',
        position: 'relative',
        cursor: 'grab',
        '&:hover': {
            transform: 'scale(1.03)',
        },
        '&:active': {
            transform: 'scale(1.07)',
            cursor: 'grabbing',
        },
        '& span': {
            textAlign: 'center',
            position: 'absolute',
            top: 40,
            left: 0,
            width: '100%',
            fontWeight: '700',
        }
    },
    lineUpContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        flexGrow: 0,
        flexShrink: 0,
        marginBottom: 1,
        padding: '8px',
        position: 'relative',
        isolation: 'isolate',
    },
    playerCircleContainer: {
        cursor: 'grab',
        position: 'relative',
        '&:hover': {
            transform: 'scale(1.03)',
        },
        '&:active': {
            transform: 'scale(1.07)',
            cursor: 'grabbing',
        }
    },
    seperator: {
        height: 'auto',
        width: '100%',
        borderTop: '1px solid',
        borderTopColor: 'rgba(255, 255, 255, 0.1)',
        marginTop: '16px',
        paddingTop: '16px',
        marginBottom: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

const Lineup = ({type}) => {
    const translate = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const isInitialMount = useRef(true);
    const hasLoadedSheetData = useRef(false);
    const theme = useTheme();
    hasTeamPlayersOnCanvas();
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const canvas = useCanvasStore(state => state.canvas);

    const setSelectedClient = useSettingsStore(state => state.setSelectedClient);
    const setSelectedEnemyClient = useSettingsStore(state => state.setSelectedEnemyClient);
    // const selectedClient = useSettingsStore(state => state.selectedClient);
    // const selectedEnemyClient = useSettingsStore(state => state.selectedEnemyClient);

    const selectedTeam = useSettingsStore((state) => state.selectedTeam);
    const setSelectedTeam = useSettingsStore(state => state.setSelectedTeam);
    const selectedTeamLineup = useSettingsStore((state) => state.selectedTeamLineup);
    const setSelectedTeamLineup = useSettingsStore((state) => state.setSelectedTeamLineup);

    const selectedEnemyTeam = useSettingsStore((state) => state.selectedEnemyTeam);
    const setSelectedEnemyTeam = useSettingsStore(state => state.setSelectedEnemyTeam);
    const selectedEnemyTeamLineup = useSettingsStore((state) => state.selectedEnemyTeamLineup);
    const setSelectedEnemyTeamLineup = useSettingsStore((state) => state.setSelectedEnemyTeamLineup);

    const lineupDirection = useSettingsStore((state) => state.lineupDirection);
    const setLineupDirection = useSettingsStore((state) => state.setLineupDirection);
    const clientQuery = useClientApiQuery();
    const clients = clientQuery.data;
    const queryTeam = useApiRead({teamId: selectedTeam});
    const queryEnemyTeam = useApiRead({teamId: selectedEnemyTeam});
    const enemyTeam = queryEnemyTeam.data;
    const team = queryTeam.data;

    const {data: queryMembers} = useApiQuery({teamId: team?.id});
    const {data: queryEnemyMembers} = useApiQuery({teamId: enemyTeam?.id});
    
    const lineupIsDragging = useLayoutStore((state) => state.lineupIsDragging);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    const drawLineup = useDrawTeamLineup();

    // const color = usePrefsStore((state) => state.color);
    const playerPrefs = usePrefsStore((state) => state.prefs.player);
    const {selectedSheet: sheet} = useSheet();
    const {update: updateSheet} = useSheetUpdate();
    
    useEffect(() => {
        console.log('Lineup useEffect first mount');
    }, []);

    useEffect(() => {
        // use sheet data to load lineup tool presets on mount
        if (hasLoadedSheetData.current === false && sheet && clients.length > 0) {
            console.log('drawlineup useEffect new sheet', sheet, hasLoadedSheetData);
            if (sheet?.lineup) {
                console.log('INITIAL MOUNT Loading lineup presets from sheet:', sheet.lineup);
                const {team1, team2} = sheet.lineup;
                // Get team IDs from canvas objects if not in sheet data
                const canvasObjects = canvas?.getObjects() || [];
                const teamIdsOnCanvas = [...new Set(
                    canvasObjects
                        .filter(obj => {
                            if (obj.custom?.type !== 'player' || !obj.custom?.team || typeof obj.custom.team !== 'string') {
                                return false;
                            }

                            // OLD SYSTEM custom players which have colorname as team, for reference use the colors export form ColorTool
                            // Check if team name matches any color from ColorTool
                            const teamName = obj.custom.team.toLowerCase();
                            if(colors.some(color => color.name.toLowerCase() === teamName) || ['home', 'guest'].includes(teamName)) {
                                return false;
                            }

                            //  is a team id
                            return true;
                        }).map(obj => obj.custom.team)
                )];
                
                console.log('Team IDs found on canvas:', teamIdsOnCanvas);
                let selectedTeam1 = null;
                // Load team1 data
                if (team1?.id) {
                    // Set selected team and lineup
                    if (team1.id !== selectedTeam) {
                        //  select client based on Team, if no client exists, dont select team
                        let teamClient = clients.find((c) => c.teams.find((t) => t === team1.id));
                        console.log('Team1 client:', teamClient);
                        if (team1.id !== '' && teamClient) {
                            setSelectedClient(teamClient);
                            setSelectedTeam(team1.id);
                            selectedTeam1 = team1.id;
                        } else {
                            // TEAM NOT FOUND
                            console.error('ERR: Team not found in Clients:', team1.id);
                            setSelectedTeam(null);
                            setSelectedClient(null);

                        }

                    }
                
                    if (team1.lineup && team1.lineup !== selectedTeamLineup) {
                        setSelectedTeamLineup(team1.lineup);
                    }
                
                    // Set direction based on team1's direction
                    if (team1.direction === 'home' && lineupDirection !== 'up') {
                        setLineupDirection('up');
                    } else if (team1.direction === 'guest' && lineupDirection !== 'down') {
                        setLineupDirection('down');
                    }
                } else if (teamIdsOnCanvas.length > 0) {
                    // No team1 in sheet, but we have teams on canvas - use first team ID
                    console.log('No team1 in sheet, setting from canvas:', teamIdsOnCanvas[0]);
                    let teamClient = clients.find((c) => c.teams.find((t) => t === teamIdsOnCanvas[1]));
                    console.log('teamIdsOnCanvas1 client:', teamClient);
                    if (teamIdsOnCanvas[1] !== selectedEnemyTeam&& teamClient) {
                        setSelectedClient(teamClient);
                        setSelectedTeam(teamIdsOnCanvas[0]);
                        selectedTeam1 = teamIdsOnCanvas[0];
                    } else {
                        // sheet has no selected Team
                        setSelectedTeam(null);
                        setSelectedClient(null);
                    }
                    // sheet has no selected Team
                } else {
                    // sheet has no selected Team and no canvas data
                    setSelectedClient(null);
                    setSelectedTeam(null);
                    setSelectedTeamLineup(null);
                }
            
                // Load team2 data
                if (team2?.id ) {
                    // Set selected enemy team and lineup
                    if (team2.id !== selectedEnemyTeam) {
                        // Update selected enemy team in settings store
                        console.log('Updating selected enemy team in settings store:', team2.id);
                        let enemyTeamClient = clients.find((c) => c.teams.find((t) => t === team2.id));
                        
                        if (team2.id !== '' && enemyTeamClient && team2.id !== selectedTeam1) {
                            setSelectedEnemyTeam(team2.id);
                            setSelectedEnemyClient(enemyTeamClient);
                        } else {
                            // TEAM NOT FOUND
                            console.error('ERR: ENEMY Team not found in Clients or duplicate with team1:', team2.id);
                            setSelectedEnemyTeam(null);
                            setSelectedEnemyClient(null);

                        }
                    }
                
                    if (team2.lineup && team2.lineup !== selectedEnemyTeamLineup) {
                        setSelectedEnemyTeamLineup(team2.lineup);
                    }
                } else if (teamIdsOnCanvas.length > 1) {
                    // No team2 in sheet, but we have multiple teams on canvas - use second team ID
                    console.log('No team2 in sheet, setting from canvas:', teamIdsOnCanvas[1]);
                    let enemyTeamClient = clients.find((c) => c.teams.find((t) => t === teamIdsOnCanvas[1] && t !== selectedTeam1));
                    console.log('teamIdsOnCanvas1 client:', enemyTeamClient);
                    if (!teamIdsOnCanvas[1] === selectedTeam && enemyTeamClient) {
                        setSelectedEnemyTeam(teamIdsOnCanvas[1]);
                        setSelectedEnemyClient(enemyTeamClient);
                    } else {
                        // sheet has no selected Team
                        setSelectedEnemyTeam(null);
                        setSelectedEnemyClient(null);
                    }
                } else {
                    // sheet has no selectable Team
                    // sheet has no selected Team
                    setSelectedEnemyClient(null);
                    setSelectedEnemyTeam(null);
                    setSelectedEnemyTeamLineup(null);
                }

                // finally set hasLoadedSheetData to true
                hasLoadedSheetData.current = true;

            } else { 
                // error no lineup - set to loaded as well
                console.error('No lineup found in sheet');
                hasLoadedSheetData.current = true;

            }
            
        } 

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sheet, clients]);

    // Update sheet when teams, direction, or lineups change
    useEffect(() => {
        if (!sheet || hasLoadedSheetData === false || isInitialMount.current) {
            return;
        }
        // Update sheet on selectedTeam/selectedEnemyTeam change, direction change and lineup changes 

        const updateSheetLineup = async () => {
            const currentLineup = sheet.lineup || {};
            console.log('updateSheetLineup', currentLineup);
            // replace 'up' and 'down' because in sheets its home and guest 
            const updatedLineup = {
                ...currentLineup,
                team1: {
                    direction: lineupDirection === 'up'? 'home' : 'guest', // Team gets direction,
                    id: selectedTeam,
                    lineup: selectedTeamLineup || team?.lineup
                },
                team2: {
                    direction: lineupDirection === 'up' ? 'guest' : 'home', // Enemy team gets opposite direction
                    id: selectedEnemyTeam,
                    lineup: selectedEnemyTeamLineup || enemyTeam?.lineup
                }
            };

            // Only update if there are actual changes
            if (JSON.stringify(currentLineup) !== JSON.stringify(updatedLineup)) {
                try {
                    await updateSheet({
                        ...sheet,
                        lineup: updatedLineup
                    });
                    console.log('Sheet lineup updated:', updatedLineup);
                } catch (error) {
                    console.error('Failed to update sheet lineup:', error);
                }
            }
        };

        if (selectedTeam || selectedEnemyTeam) {
            updateSheetLineup();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTeam, selectedEnemyTeam, selectedTeamLineup, selectedEnemyTeamLineup, lineupDirection]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }

        // Only draw lineup on direction change for already placed lineups 
        // NEW SYSTEM HAS TEAM DATA IN SHEETS
        const hasPlacedTeamLineup = sheet?.lineup?.team1?.id;
        const hasPlacedEnemyLineup = sheet?.lineup?.team2?.id;
        
        if (team && selectedTeamLineup && hasPlacedTeamLineup && hasTeamPlayersOnCanvas(canvas, team?.id)) {
            console.log('drawlineup direction home useeffect', selectedTeamLineup);
            doDrawLineup(selectedTeamLineup || team?.lineup, false);
        }

        if (enemyTeam && selectedEnemyTeamLineup && hasPlacedEnemyLineup && hasTeamPlayersOnCanvas(canvas, enemyTeam?.id)) {
            console.log('drawlineup direction enemy useeffect', selectedEnemyTeamLineup);
            doDrawLineup(selectedEnemyTeamLineup || enemyTeam?.lineup, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lineupDirection]);

    const doDrawLineup = (lineup, isEnemy) => {
        // lineupdirection is always the home team , so we switch direction for enemy to draw enemy lineup
        if (isEnemy) {
            // reverse direction for enemy
            setSelectedEnemyTeamLineup(lineup);
            // reverse direction for enemy
            let enemyDirection = lineupDirection === 'up' ? 'down' : 'up';
            console.log('drawlineup enemy', enemyTeam.name, lineup, enemyDirection);
            drawLineup(queryEnemyMembers, enemyTeam, lineup, enemyDirection, enemyTeam?.prefs?.player?.type || playerPrefs.type, playerPrefs.size, type);
        } else {
            setSelectedTeamLineup(lineup);
            console.log('drawlineup', team.name, lineup, lineupDirection);
            drawLineup(queryMembers, team, lineup, lineupDirection, team?.prefs?.player?.type || playerPrefs.type, playerPrefs.size, type);
        }
    
    };

    const onSave = async (updatedTeam) => {
        console.log('onSave', updatedTeam);
        setShowEdit(false);
        if (type === 'home') {
            await queryTeam.refetch();
        }

        if (type === 'guest') {
            await queryEnemyTeam.refetch();
        }
    };

    return (
        <Stack
            direction="column"
            alignItems="center"
            sx={{
                ...styles.lineUpContainer,
                ...((lineupIsDragging && isMobile) && styles.drawerInvisible)
            }}>

            {type ==='home' ? team && <Typography sx={styles.teamTitle}>{team?.name}:</Typography> : enemyTeam && <Typography sx={styles.teamTitle}>{enemyTeam?.name}:</Typography> }

            {showEdit && <Edit team={type === 'home' ? team : enemyTeam} onClose={() => setShowEdit(false)} onSave={onSave}/>}

            {type === 'home' && team || type === 'guest' && enemyTeam ? (
                <Accordion
                    expanded={expanded === 'panel0' || (type === 'home' && !team) || (type === 'guest' && !enemyTeam)}
                    onChange={handleChange('panel0')}
                    sx={[styles.accordion(theme), expanded === 'panel0' && styles.accordionActive(theme)]}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel0-content"
                        id="panel0-header"
                        sx={styles.accordionSummary}
                    >
                        <Typography sx={[styles.accordionTitle(theme), expanded === 'panel0' && styles.accordionTitleActive(theme)]}>
                            {translate('board.lineup.team.drag_onto_field')}:
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={styles.accordionDetails(theme)}>

                        <Player type={type} team={team} enemyTeam={enemyTeam} teamMembers={queryMembers} enemyTeamMembers={queryEnemyMembers} />

                        <Box sx={styles.seperator}>
                            <Typography sx={{color: 'white', fontSize: '14px', marginBottom: '6px'}}>
                                {translate('board.lineup.team.settings')}
                            </Typography>
                            <IconButton
                                onClick={() => setShowEdit(true)}
                                sx={{
                                    ...styles.settingsButton(theme),
                                }}
                            >
                                <SettingsIcon />
                            </IconButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ): null}

            {(type === 'home' && team) || (type === 'guest' && enemyTeam) ? (
                <Accordion
                    expanded={expanded === 'panel2'}
                    onChange={handleChange('panel2')}
                    sx={[styles.accordion(theme), expanded === 'panel2' && styles.accordionActive(theme)]}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        sx={styles.accordionSummary}
                    >
                        <Typography sx={[styles.accordionTitle(theme), expanded === 'panel2' && styles.accordionTitleActive(theme)]}>
                            {translate('board.lineup.team.squad')}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={styles.accordionDetails(theme)}>
                        <Box sx={{position: 'relative'}}>
                            <TeamLineup type={type} team={type === 'home' ? team : enemyTeam} />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ): null}

            {(type === 'home' && team) || (type === 'guest' && enemyTeam) ? (
                <Accordion
                    expanded={expanded === 'panel3'}
                    onChange={handleChange('panel3')}
                    sx={[lineupIsDragging && styles.buttonInvisible, styles.accordion(theme), expanded === 'panel3' && styles.accordionActive(theme)]}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                        sx={styles.accordionSummary}
                    >
                        <Typography sx={[styles.accordionTitle(theme), expanded === 'panel3' && styles.accordionTitleActive(theme)]}>
                            {translate('board.lineup.team.lineup')}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={styles.accordionDetails(theme)}>
                        <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'flex-start', alignItems: 'center', paddingTop: '12px'}}>
                            {homeLineup
                                .sort((a, b) => {
                                    const defaultLineup = type === 'home' ? team?.lineup : enemyTeam?.lineup;
                                    if (a.name === defaultLineup) return -1;
                                    if (b.name === defaultLineup) return 1;
                                    return 0;
                                })
                                .map(l => {
                                    const currentSelectedLineup = type === 'home' ? selectedTeamLineup : selectedEnemyTeamLineup;
                                    const isSelected = currentSelectedLineup === l.name || (!currentSelectedLineup && team?.lineup === l.name);
                                    const isEnemySelected = currentSelectedLineup === l.name || (!currentSelectedLineup && enemyTeam?.lineup === l.name);

                                    return (
                                        <Stack
                                            key={l.name}
                                            onClick={() => doDrawLineup(l.name, type !== 'home')}
                                            sx={{
                                                ...styles.iconBoxGroup(theme),
                                                ...((isSelected || isEnemySelected) && styles.iconBoxGroupSelected(theme))
                                            }}
                                        >
                                            <Box sx={styles.iconBox}>
                                                <l.Icon style={styles.icon} />
                                            </Box>
                                            <Typography align="center" sx={styles.iconBoxText(theme)}>
                                                {l.name}
                                            </Typography>
                                        </Stack>
                                    );
                                })}
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ) : null}

            {(type === 'home' && team) || (type === 'guest' && enemyTeam) ? (
                <Accordion
                    expanded={expanded === 'panel4'}
                    onChange={handleChange('panel4')}
                    sx={[lineupIsDragging && styles.buttonInvisible, styles.accordion(theme), expanded === 'panel4' && styles.accordionActive(theme)]}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                        sx={styles.accordionSummary}
                    >
                        <Typography sx={[styles.accordionTitle(theme), expanded === 'panel4' && styles.accordionTitleActive(theme)]}>
                            {translate('board.lineup.team.playing_direction')}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{...styles.accordionDetails(theme), textAlign: 'center', padding: '8px'}}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                            <IconButton
                                onClick={() => setLineupDirection('up')}
                                disabled={lineupDirection === 'up' && true}
                                sx={{
                                    ...styles.directionButton(theme),
                                    ...(lineupDirection === 'up' && {
                                        ...styles.directionButtonActive(theme)
                                    }),
                                }}>
                                <ArrowUpIcon sx={{fontSize: '18px'}} />
                            </IconButton>
                            <IconButton
                                onClick={() => setLineupDirection('down')}
                                disabled={lineupDirection === 'down' && true}
                                sx={{
                                    ...styles.directionButton(theme),
                                    ...(lineupDirection === 'down' && {
                                        ...styles.directionButtonActive(theme)
                                    }),
                                }}>
                                <ArrowDownIcon sx={{fontSize: '18px'}} />
                            </IconButton>
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            ): null}

            <Accordion
                expanded={expanded === 'panel1' || (type === 'home' && !team) || (type === 'guest' && !enemyTeam)}
                onChange={handleChange('panel1')}
                sx={[lineupIsDragging && styles.buttonInvisible, styles.accordion(theme), expanded === 'panel1' && styles.accordionActive(theme)]}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={styles.accordionSummary}
                >
                    <Typography sx={[styles.accordionTitle(theme), expanded === 'panel1' && styles.accordionTitleActive(theme)]}>
                        {/* type ==='home' ? team ? team?.name : 'Wähle dein Team aus:' : enemyTeam ? enemyTeam?.name : 'Wähle das Gegnerteam aus:' */}
                        {type ==='home' ? team ? translate('board.lineup.your_team') : translate('board.lineup.choose_team') : enemyTeam ? translate('board.lineup.opponent_team') : translate('board.lineup.choose_opponent_team')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={styles.accordionDetails(theme)}>
                    <TeamSelector type={type} closePanel={handleChange('null')} />
                </AccordionDetails>
            </Accordion>

        </Stack>
    );
};

export default Lineup;